/**
 * DEVELOPER DOCUMENTATION
 * 
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

 var swiper = new Swiper(".hotSwiper", {
        slidesPerView: 4,
        spaceBetween: 3,
       breakpoints: { 
      320: {  
         slidesPerView:2,
        spaceBetween: 1,
        noSwiping: true
      },
      768: {   
         slidesPerView: 3,
        spaceBetween: 3,
      },
      1280: {  
          slidesPerView: 4,
        spaceBetween: 3,
      }
    }
      });
 var swiper = new Swiper(".iisliSwiper", {
        slidesPerView: 1,
        loop:true,
        pagination: {
          el: ".ii_page",
        },
        navigation: {
          nextEl: ".io_n",
          prevEl: ".io_p",
        },
      });
$('#myVideo').show().trigger("play").bind('ended', function () { 
    this.currentTime = 0;
})
 var swiper = new Swiper(".diisliSwiper", {
        slidesPerView: 1,
      pagination: {
          el: ".dii_page",
        },
      });
 var swiper = new Swiper(".yakaSwiper", {
        slidesPerView: 3,
        spaceBetween: 3,
   loop:true,
       navigation: {
          nextEl: ".kn",
          prevEl: ".kp",
        },
 
    speed:3000,
    autoplay: true,
    breakpoints: { 
    320: {  
         slidesPerView: 2,
        spaceBetween: 3,
      },
      768: {   
         slidesPerView: 3,
        spaceBetween: 3,
      },
      1280: {  
          slidesPerView: 3,
        spaceBetween: 3,
      }
    }
      });
 
 var swiper = new Swiper(".conSwiper", {
        slidesPerView: 1,
   loop:true,
   autoplay:true,
      navigation: {
          nextEl: ".bgn",
          prevEl: ".bgp",
        },
      });

 var swiper = new Swiper(".CustomerSwiper", {
        slidesPerView: 4,
        loop:true,
    speed:6000,
    autoplay: {
    delay: 100,
    },
      breakpoints: { 
    320: {  
         slidesPerView: 2,
        spaceBetween: 0,
      },
      768: {   
        slidesPerView: 4,
        spaceBetween: 0,
      },
      1280: {  
         slidesPerView: 4,
        spaceBetween: 0,
      }
    }
      });

 var swiper = new Swiper(".blogSwiper", {
       slidesPerView: 3,
      loop:true,
        spaceBetween: 45,
        navigation: {
          nextEl: ".bn",
          prevEl: ".bp",
        },
       speed:3000,
    breakpoints: { 
    320: {  
         slidesPerView: 1.2,
        spaceBetween: 10,
      },
      768: {   
        slidesPerView: 3,
        spaceBetween: 10,
      },
      1280: {  
         slidesPerView: 3,
        spaceBetween: 45,
      }
    }
      });
 var swiper = new Swiper(".consSwiper", {
     
        spaceBetween: 30,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
     breakpoints: { 
    320: {  
         slidesPerView: 2,
       spaceBetween: 10,
      },
      768: {   
        spaceBetween: 30,
        slidesPerView: 5,
      },
      1280: {  
         spaceBetween: 30,
        slidesPerView: 5,
      }
    }
      });
      var swiper2 = new Swiper(".consSwiper2", {
       
      
        navigation: {
          nextEl: ".bbb_n",
          prevEl: ".bbb_p",
        },
        thumbs: {
          swiper: swiper,
        },
      });
 var swiper = new Swiper(".picSwiper", {
        slidesPerView: 6,
       spaceBetween: 10,
   loop:true,
    speed:6000,
    autoplay: {
    delay: 100,
    },
    breakpoints: { 
    320: {  
         slidesPerView: 2,
       spaceBetween: 10,
      },
      768: {   
        slidesPerView: 6,
       spaceBetween: 10,
      },
      1280: {  
         slidesPerView: 6,
       spaceBetween: 10,
      }
    }
      });

 var swiper = new Swiper(".ServicesSwiper", {
        slidesPerView: 3,
        spaceBetween: 0,
       breakpoints: { 
    320: {  
         slidesPerView: 2,
        spaceBetween: 0,
      },
      768: {   
         slidesPerView: 3,
        spaceBetween: 0,
      },
      1280: {  
         slidesPerView: 3,
        spaceBetween: 0,
      }
    }
      });



 var swipersc = new Swiper(".scSwiper", {
        direction: "vertical",
       mousewheel: true,

      });

 $('.custom_image .section-scroll-content ').hover(function () {
            $(this).addClass('active').siblings().removeClass('active');
         
        })

 $('.about_item').hover(function () {
            $(this).addClass('first_select').siblings().removeClass('first_select');
         
        })
$('.order_top').click(function(){
  $('body,html').animate({scrollTop:0},1000); 
})
// $('.sugg_a a').click(function(){
  
//   $('.predictive-search__input').val($(this).text());

//  $('.predictive-search__input').keydown(function(e){
//     if(e.keyCode==13){
//        $('.predictive-search__input').val($(this).text());
//     }
// });
                     
// })

var swiper = new Swiper(".searchswiper", {
   slidesPerView: 2.3,
        spaceBetween: 15,
        pagination: {
          el: ".faq_pag",
          type: "progressbar",
        },
       breakpoints: { 
    320: {  
          slidesPerView: 1.3,
        spaceBetween: 15,
      },
      768: {   
          slidesPerView: 2.3,
        spaceBetween: 15,
      },
      1280: {  
          slidesPerView: 2.3,
        spaceBetween: 15,
      }
    }
       
      });

var swiper = new Swiper(".hotaSwiper", {
        slidesPerView: 2,
  navigation: {
          nextEl: ".sen",
          prevEl: ".sep",
        },
  loop:true,
 spaceBetween: 15,
    breakpoints: { 
   320: {  
          slidesPerView: 1.3,
        spaceBetween: 15,
      },
      768: {   
          slidesPerView: 2,
 
 spaceBetween: 15,
      },
      1280: {  
         slidesPerView: 2,
 
 spaceBetween: 15,
      }
    }
      });

$('.fea_dot').hover(function(){
    $(this).addClass("actived")
  

 
},function(){
   $(this).removeClass("actived")
})


var swiper = new Swiper(".dotsSwiper", {
        slidesPerView: 5,
 loop:true,
 spaceBetween: 15,
   navigation: {
          nextEl: ".don",
          prevEl: ".dop",
        },
    breakpoints: { 
   320: {  
          slidesPerView: 2,
        spaceBetween: 15,
      },
      768: {   
          slidesPerView: 3,
 
 spaceBetween: 15,
      },
      1280: {  
         slidesPerView: 5,
 
 spaceBetween: 15,
      }
    }
      });

var swiper = new Swiper(".compareSwiper", {
        slidesPerView: 6,

 spaceBetween: 0,
  
    breakpoints: { 
   320: {  
          slidesPerView: 2,
        spaceBetween: 0,
      },
      768: {   
          slidesPerView: 3,
 
 spaceBetween: 0
      },
      1280: {  
         slidesPerView: 6,
 
 spaceBetween: 0,
      }
    }
      });
var swiperw = new Swiper(".comparesSwiper", {
     
      
      
      });
      var swiper2 = new Swiper(".comparesSwiper2", {
       
      
        navigation: {
          nextEl: ".comp_n",
          prevEl: ".comp_p",
        },
        thumbs: {
          swiper: swiperw,
        },
      });
   $('.access_item').click(function(){
 
            $(this).addClass('actived').siblings().removeClass("actived")
 
            var index=$(this).index()
           $('.access_pic div').eq(index).show().siblings().hide()
          
        })
$('.close_mm').click(function(){
 
            $(".fea_dot").removeClass("actived")
 
           
          
        })
